/** @file Matches a key event to a binding by physical key code and exact modifiers (layout-independent). */
import type { Binding, KeyEventLike, Platform } from './types';
import { parseKeys } from './parseKeys';

/** True when the event's code and modifiers equal the binding's chord. Ignores events during IME composition. */
export function matchEvent(binding: Binding, event: KeyEventLike, platform: Platform): boolean {
  if (event.isComposing) return false;
  const chord = parseKeys(binding.keys, platform);
  return (
    event.code === chord.code &&
    event.ctrlKey === chord.ctrl &&
    event.metaKey === chord.meta &&
    event.shiftKey === chord.shift &&
    event.altKey === chord.alt
  );
}
